
//prod
let url= "https://www.rsklog.com" //BBDD Lightsail

//pre-prod
//let url= "https://www.rskgroup.tk" //BBDD .tk 3306

//local
let local_url = "http://127.0.0.1"

export const  urlConfig = {
    allUrl:url,
    inspectorUrl:`${url}:9002/api/v1/inspector`,
    currencyUrl:`${url}:9002/api/v1/currency/`,
};
